/**
 * Os passos para desbloquear os avisos no navegador (permissão `denied`) e, logo abaixo, a nota do iPhone (`textos.bloqueado.rodape`,
 * a única frase que leva o nome do app). O cartão de Preferências (estado "bloqueado") e o aviso flutuante (`AvisoDoPush`, tipo
 * `bloqueado`) dizem a mesma coisa; cada um põe a sua frase de abertura antes (`bloqueado.intro` no cartão, `aviso.desbloquearIntro` no
 * aviso). Os passos são os que estavam inline no `CartaoPushDoAparelho`, extraídos sem mudar uma palavra.
 *
 * O 3º passo é o único que muda de um lugar para o outro (`terceiroPasso`). No cartão de Preferências vale o de sempre, que manda ligar
 * "nesta tela" (lá está o botão Ligar). No aviso flutuante é só "Recarregue a página.": depois de desbloquear e recarregar, a
 * sincronização religa sozinha (intenção `ligado`, permissão `granted`), e o aviso nem tem botão de ligar.
 */
import { Lock } from "lucide-react";

import type { TextosDoPush } from "./CartaoPushDoAparelho.textos";

const PALAVRA_DO_PASSO = "font-medium text-foreground";

/** O 3º passo no cartão de Preferências (o padrão), palavra por palavra como era inline. */
const TERCEIRO_PASSO_DO_CARTAO = "Recarregue a página e ligue os avisos nesta tela.";

interface Props {
  textos: TextosDoPush;
  /** O 3º passo. Sem ele, o do cartão de Preferências. */
  terceiroPasso?: string;
}

export function PassosParaDesbloquear({
  textos,
  terceiroPasso = TERCEIRO_PASSO_DO_CARTAO,
}: Props): JSX.Element {
  return (
    <>
      <ol className="list-decimal space-y-1 pl-4">
        <li>
          Clique (ou toque) no{" "}
          <Lock aria-hidden="true" className="inline h-3.5 w-3.5 align-text-bottom" />{" "}
          <strong className={PALAVRA_DO_PASSO}>cadeado</strong>, ou no ícone de ajustes, à esquerda
          do endereço na barra do navegador.
        </li>
        <li>
          Em <strong className={PALAVRA_DO_PASSO}>Notificações</strong>, escolha{" "}
          <strong className={PALAVRA_DO_PASSO}>Permitir</strong>.
        </li>
        <li>{terceiroPasso}</li>
      </ol>
      <p>{textos.bloqueado.rodape}</p>
    </>
  );
}
